import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AssetAvailableDeviceModel, AssetGqlModel} from "./asset.gql-model";
import { DropdownsModel, ListSiteGroupModel, SiteContactsModel, PurchaseOrderModel } from "../workflow/site/assets-dropdowns-info-model";
import { ItsmContactModel } from "../contact/itsm-contact.model";
import { ItsmAddressModel } from "../address/itsm-address.model";
import { handleErrors } from "../misc/handle-errors.decorator";
import { AssetService } from "./asset.service";
import { ContactService } from "../contact/contact.service";
import { AddressService } from "../address/address.service";
import { WorkflowService } from "../workflow/workflow.service";
import { StandaloneAccessoryGqlModel } from "../accessory/standalone-accessory.gql-model";
import { dorLegacyDocumentType, dorMultiPoTypeOptionsConst, dorRenewalOptionsConst } from "../types/simplify-constants";
import { BrokerApiContractAccountDataModel, ProjectModel } from "../project/project.model";
import { CostCenterModel, costCenterModelFactory } from "../cost-center/cost-center.model";
import { AppSettingsService } from "../app-settings/app-settings.service";
import { CostCenterService } from "../cost-center/cost-center.service";
import { clone } from "lodash";
import {BillFromValue} from "../bill-from/bill-from-with-region.model";
import { acquisitionMethod } from "../types/simplify-constants";
import {ProjectService} from "../project/project.service";
import {contactTypes} from "../types/contact";
import { Query } from "../graphql/query-constant";
import { HasuraGraphqlService } from "../graphql/hasura-graphql-service";
const _ = require('lodash');
export interface DataFromEditAccessoryModel {
  accessories: StandaloneAccessoryGqlModel[];
  changes: boolean;
  accessoriesSaved?: boolean;
  errors: string;
}

@Component({
  selector: "edit-asset",
  templateUrl: "./edit-asset.template.pug",
  providers:[
    HasuraGraphqlService
  ],
})
export class EditAssetComponent implements OnInit {
  @Output() public closeSelected = new EventEmitter();
  @Output() public removeSelected = new EventEmitter();
  @Output() public saveSelected = new EventEmitter();
  @Output() public detectAssetChanges = new EventEmitter();
  @Input() public projectId: string;
  @Input() public stepName: string;
  @Input() public currentAsset: AssetGqlModel;
  @Input() public currentDevice: AssetAvailableDeviceModel;
  @Input() public groups: ListSiteGroupModel[];
  @Input() public isCOALinkEditable: boolean;
  @Input() public siteContacts: SiteContactsModel[];
  @Input() public purchaseOrders: PurchaseOrderModel[];
  @Input() public itsmSiteContacts: ItsmContactModel[];
  @Input() public addresses: ItsmAddressModel[];
  @Input() public dropdowns: DropdownsModel;
  @Input() public statusKey: string;
  @Input() public statusDetail: string;
  @Input() public defaultContacts: {serviceAddressId?: string, tonerAddressId?: string} = {};
  @Input() public project: ProjectModel;
  @Input() public costCenters: CostCenterModel[];
  @Input() public itsmCustomerId: string;
  @Input() public showProviderContractId: boolean = true;
  @Input() public processingFlag: boolean = false;
  @Input() public enableCustomFields: boolean = false;
  @Input() public enableMultipleCA: boolean;
  @Input() public siteContract: SiteContactsModel[];
  @Input() public itsmContractAccount: BrokerApiContractAccountDataModel[];
  @Input() public billFromAccounts: BillFromValue[];
  @Input() public ContractualContactTypes: any;
  @Input() public itsmContactsWithBpIdMap: any;
  @Input() public disableCOALink: boolean = false;
  por922TMC: boolean;
  @Input() public set itsmCustomInformation(val) {
    this.itsmCustomHeaders = val;
    if (this.enableCustomFields) {
      this.updateCustomHeaders();
    }
  };
  @Input() public enableAssetColors: boolean = false;
  itsmCustomHeaders = [] // [{ "number": 1, "value": "Header 1" }]
  public customFields = [];
  public urlInvalid: any;

  private selectedCostCenter: CostCenterModel = costCenterModelFactory({});
  public error: Error;
  public site: string;
  public originalCurrentAsset: AssetGqlModel;
  public page = "details";
  public changesMade: boolean = false;
  public saveSoftwareButon: boolean = false;
  public saveContractualContactButon: boolean = true;
  public savedSoftware: boolean = false;
  public savedContractualContact: boolean = false;
  public assetDetailsChanged: boolean = false;
  public currentAssetBundledAccessoriesString = "";
  isMigrationProject = false;
  dorMultiPoTypeOptions = dorMultiPoTypeOptionsConst;
  dorLegacyDocumentOptions = dorLegacyDocumentType;
  dorRenewalOptionsOptions = dorRenewalOptionsConst;
  enableCostCenters: boolean;
  CR923: boolean;
  enableAdditionalFieldsForMigration: boolean;
  POR165_TMC: boolean;
  POR165: boolean;
  enablePor165: boolean;
  enableBillFrom: boolean;
  public acquisitionMethod = acquisitionMethod;
  //enableCustomFields: boolean;
  public emeaAssetFields: string[] = [
    "custom1",
    "custom2",
    "custom3",
    "custom4",
    "custom5",
    "custom6",
    "custom7",
    "custom8",
    "custom9",
    "custom10",
  ];
  errorDetail:string = 'yes';
  contactInfo = {
    toner: {
      name: "toner",
      humanReadableTitle: "Consumable Contact",
      id: "toner_contact_id",
      idUpdate: "assetTonerContactId",
      defaultId: "siteTonerContactId",
      allowCreate: true,
      requireBpId: false,
    },
    breakfix: {
      name: "breakfix",
      humanReadableTitle: "Service Delivery Contact",
      id: "breakfix_contact_id",
      idUpdate: "assetBreakfixContactId",
      defaultId: "siteBreakfixContactId",
      allowCreate: true,
      requireBpId: false,
    },
    installation: {
      name: "installation",
      humanReadableTitle: "Installation Contact",
      id: "installation_contact_id",
      idUpdate: "assetInstallationContactId",
      defaultId: "siteInstallationContactId",
      allowCreate: true,
      requireBpId: false,
    },
    orderStatusNot1: {
      name: "order1",
      humanReadableTitle: "Order Status Contact 1",
      id: "order_status_notification_1",
      idUpdate: "assetOrderStatusNotification1Id",
      defaultId: "siteOrderStatusNotification1",
      allowCreate: true,
      requireBpId: false,
    },
    orderStatusNot2: {
      name: "order2",
      humanReadableTitle: "Order Status Contact 2",
      id: "order_status_notification_2",
      idUpdate: "assetOrderStatusNotification2Id",
      defaultId: "siteOrderStatusNotification2",
      allowCreate: true,
      requireBpId: false,
    },
  };

  addressesInfo = {
    toner: {
      name: "consumableAddress",
      humanReadableTitle: "Consumable Address",
      id: "assetTonerAddressId",
      defaultId: "siteTonerAddressId",
      readOnly: false,
      defaultAddress: {
        deliveryType: "DOCK",
        customShippingLabel1: "",
        customShippingLabel2: "",
      },
      allowCreate: true,
      requireBpId: false,
    },
    service: {
      name: "serviceAddress",
      humanReadableTitle: "Service Address",
      id: "assetServiceAddressId",
      defaultId: "siteServiceAddressId",
      readOnly: false,
      defaultAddress: {
        deliveryType: null,
        customShippingLabel1: "",
        customShippingLabel2: "",
      },
      allowCreate: true,
      requireBpId: false,
    },
  };

  contactHumanReadableNames: any = contactTypes.filter(it => it.level === "contractualContact");

  contactMap: any = {};
  settableContacts: ItsmContactModel[];
  settableContactsMap: any = {};

  addressMap: any = {};
  settableAddresses: ItsmAddressModel[] = [];
  settableAddressesMap: any = {};
  enableCSEP2Workflow: boolean = false;

  deliveryTypes: any = [
    { key: "", humanReadable: "" },
    { key: "DOCK", humanReadable: "Dock delivery" },
    { key: "DESKTOP", humanReadable: "Desktop delivery" },
  ];

  deliveryTypeHumanReadableMap: any = this.deliveryTypes
    .reduce((acc, it) => { acc[it.key] = it.humanReadable; return acc; }, {});

  assetStateList = [
    { key: "missing-information", text: "Missing or invalid asset details", color: "#eb9b03", icon: "warning" },
    { key: "ready", text: "Ready to upload", color: "#000000", icon: "none" },
    { key: "future-install-date", text: "Project don't allow future install date", color: "#6f1212", icon: "error" },
    { key: "upload-failed", text: "Upload failed", color: "#6f1212", icon: "error" },
    { key: "exists-in-k2", text: "Device is in K2", color: "#0f590f", icon: "ok" },
    { key: "found-in-k2", text: "Device was found in K2", color: "#0f590f", icon: "ok" },
    { key: "removal-in-k2", text: "Device was removed from K2", color: "#0f590f", icon: "ok" },
    { key: "validated", text: "Dry Run Successful", color: "#000000", icon: "none" },
  ];

    processing: boolean = false;
  assetColors={   
    hideColorTotal: false,
    hideColor: false,
    hideColorAccent: true,
    hideColorGeneralOffice: true, 
    hideColorOther: true
  }

  constructor(
    public assetService: AssetService,
    private contactService: ContactService,
    private addressService: AddressService,
    public workflowService: WorkflowService,
    private appSettingsService: AppSettingsService,
    private costCenterService: CostCenterService,
    private projectService: ProjectService,
    private hasuraGqlService: HasuraGraphqlService,
  ) { }

  async ngOnInit() {
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["enableCostCenters", "enableCSEP2Workflow", "additionalFieldsForMigration", "POR165_TMC", "POR165", "enableBillFrom", "CR923_COA_TMC", "POR922_TMC"]);

    this.enableCostCenters = featurePermissions["enableCostCenters"];
    this.enableCSEP2Workflow = featurePermissions["enableCSEP2Workflow"];
    this.enableAdditionalFieldsForMigration = featurePermissions["additionalFieldsForMigration"];
    this.POR165_TMC = featurePermissions["POR165_TMC"];
    this.POR165 = featurePermissions["POR165"];
    this.enablePor165 = this.POR165 || this.POR165_TMC;
    
    this.enableBillFrom = featurePermissions["enableBillFrom"];
    this.CR923 = featurePermissions["CR923_COA_TMC"];
    const por922 = featurePermissions["POR922_TMC"];
    this.por922TMC = por922;

    const billTo = _.uniqBy(this.ContractualContactTypes.billTo, 'itsmContactId');
    const accDelMgr = _.uniqBy(this.ContractualContactTypes.accDelMgr, 'itsmContactId');
    const contractAdmin = _.uniqBy(this.ContractualContactTypes.contractAdmin, 'itsmContactId');
    const hpInvoice = _.uniqBy(this.ContractualContactTypes.hpInvoice, 'itsmContactId');
    const sales = _.uniqBy(this.ContractualContactTypes.sales, 'itsmContactId');
    const invoice = _.uniqBy(this.ContractualContactTypes.invoice, 'itsmContactId');
    this.ContractualContactTypes.billTo = billTo;
    this.ContractualContactTypes.accDelMgr = accDelMgr;
    this.ContractualContactTypes.contractAdmin = contractAdmin;
    this.ContractualContactTypes.hpInvoice = hpInvoice;
    this.ContractualContactTypes.sales = sales;
    this.ContractualContactTypes.invoice = invoice;
    this.site = `${this.workflowService.readableTargetType.toUpperCase()} - ${this.workflowService.readableTargetName}`;
    this.originalCurrentAsset = clone(this.currentAsset);
    this.currentAssetBundledAccessoriesString = (this.currentAsset && this.currentAsset.bundledAccessories) ?
      this.currentAsset.bundledAccessories.map(it => it.productNumber).join(", ") :
      null;

    this.updateAddressAndContactMaps();
    this.isMigrationTargetSystem();
    if (this.enableCSEP2Workflow) this.defaultAssetTagField();

    //this.processing = false;
    if(!this.enableAssetColors){
      this.assetColors={  
        hideColorTotal:false,
        hideColor:false,
        hideColorAccent:true,
        hideColorGeneralOffice:true,
        hideColorOther:true,
      }
    }
    else if(this.currentAsset.printCapability =="Mono"){
      this.assetColors={  
        hideColorTotal:false,
        hideColor:true,
        hideColorAccent:true,
        hideColorGeneralOffice:true,
        hideColorOther:true,
      }
    }
    else if(this.currentAsset.printCapability =="MonoAndColor"){
      this.assetColors={  
        hideColorTotal:false,
        hideColor:false,
        hideColorAccent:true,
        hideColorGeneralOffice:true,
        hideColorOther:true,
      }
    }
    else if(this.currentAsset.printCapability =="MultiColorMode"){
      this.assetColors={  
        hideColorTotal:false,
        hideColor:true,
        hideColorAccent:false,
        hideColorGeneralOffice:false,
        hideColorOther:false,
      }
    }
    else {
      this.assetColors={  
        hideColorTotal:false,
        hideColor:false,
        hideColorAccent:true,
        hideColorGeneralOffice:true,
        hideColorOther:true,
      }
    }
  }

  updateUrl(event: Event) {
    const input = event.target as HTMLInputElement;
    this.currentAsset.assetCOADocumentLink = input.value.trim();
    this.validateUrl();
  }

  validateUrl() {
    const url = this.currentAsset.assetCOADocumentLink;
    this.urlInvalid = url && !url.startsWith('https://');
  }


  private updateCustomHeaders() {
    this.customFields = [];
    for (let i = 1; i < 11; i++) {
      this.customFields.push({ customNumber: i, customLabel: "", key: `custom${i}`, header: `Custom ${i}`, isvalid: true });
    }
    if (this.itsmCustomHeaders.length > 0) {
      this.itsmCustomHeaders.forEach(ic => {
        let field = this.customFields.find(c => c.customNumber == ic.number);
        field.customLabel = ic.value;
        field.header = ic.value + ` (Custom ${ic.number})`;
      });
    }
  }

  defaultAssetTagField() {
    if (this.currentAsset.serialNumber && !this.currentAsset.assetTag) {
      this.currentAsset.assetTag = this.currentAsset.serialNumber.slice(0, 30);
      this.currentAsset.formGroup.controls["assetTag"].markAsDirty();
    }
  }

  updateAddressAndContactMaps() {
    this.contactMap = this.itsmSiteContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.settableContacts = this.itsmSiteContacts.filter(it => it.itsmContactId);
    this.settableContactsMap = this.settableContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});

    this.addressMap = this.addresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.settableAddresses = this.addresses
      .filter(it => it.itsmBuildingId);
    this.settableAddressesMap = this.settableAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
  }

  async checkCurrentAssetChanges() {
    const assetKeys = await Object.keys(this.currentAsset);
    for (const key of assetKeys) {
      if (
        this.currentAsset[key] !== this.originalCurrentAsset[key] &&
        (key !== "standaloneAccessories" && key !== "software")
      ) {
        this.assetDetailsChanged = true;
        this.changesMade = true;
        this.savedContractualContact = false;
        this.saveContractualContactButon = true;
        this.currentAsset.formGroup.controls[key].markAsDirty();
      } else if (!this.enableCustomFields && this.emeaAssetFields.includes(key) && !this.currentAsset.formGroup.controls[key].dirty) {
        this.currentAsset.formGroup.controls[key].markAsDirty();
      }
       else if (this.currentAsset.statusKey === 'rejected-asset' && this.stepName === 'deployDevices') {
        this.assetDetailsChanged = true;
        this.changesMade = true;
        this.savedContractualContact = false;
        this.saveContractualContactButon = true;
        this.currentAsset.formGroup.controls["statusKey"].markAsDirty();
      }
    }
    if(this.assetDetailsChanged) {
      await this.updateMultiSiteDownloadStaus();
    }
  }

  stringToBoolean(value: string): boolean {
    if (value === "false") return false;
    return true;
  }

  @handleErrors()
  async editContact(type: "toner" | "breakfix" | "installation" | "orderStatusNot1" | "orderStatusNot2"): Promise<void> {
    const contactInfo = this.contactInfo[type];
    if (!contactInfo) throw new Error("Contact type not found");

    const selectedTmcContactId = this.currentAsset[contactInfo.id];
    const modalResults = await this.assetService.selectAssetContact({
      projectId: this.projectId,
      allowCreate: contactInfo.allowCreate,
      requireBpId: contactInfo.requireBpId,
      selectedTmcContactId,
      itsmContacts: this.itsmSiteContacts,
      contactService: this.contactService,
      titleModifier: contactInfo.humanReadableTitle,
      site: this.site,
      spreadsheet: true,
    });

    if (modalResults && modalResults.changed) {
      await this.updateMultiSiteDownloadStaus();
      const foundContact = this.itsmSiteContacts.find(it => it.id === modalResults.selectedContactId);
      if (
        contactInfo.allowCreate &&
        !foundContact &&
        modalResults.createdContact &&
        modalResults.createdContact.id &&
        modalResults.createdContact.itsmContactId
      ) {
        await this.itsmSiteContacts.push(modalResults.createdContact);
        this.updateAddressAndContactMaps();
        this.contactMap[modalResults.createdContact.id].name = `${modalResults.createdContact.firstName} ${modalResults.createdContact.lastName}`;
        this.currentAsset[contactInfo.id] = modalResults.selectedContactId;
        await this.saveAddressesAndContacts();
        this.originalCurrentAsset[contactInfo.id] = modalResults.selectedContactId;
        this.addContactToDropdown(modalResults.createdContact);
      } else if (foundContact) {
        this.currentAsset[contactInfo.id] = modalResults.selectedContactId;
        await this.saveAddressesAndContacts();
        this.originalCurrentAsset[contactInfo.id] = modalResults.selectedContactId;
        this.addContactToDropdown(foundContact);
      } else {
        this.error = new Error("Selected contact does not exist");
      }
    }
  }

  @handleErrors()
  async editAddress(type: "service" | "toner"): Promise<void> {
    const addressInfo = this.addressesInfo[type];
    if (!addressInfo) throw new Error("Address type not found");
    const modalResults = await this.assetService.selectAssetAddress({
      projectId: this.projectId,
      allowCreate: addressInfo.allowCreate,
      requireBpId: addressInfo.requireBpId,
      selectedTmcAddressId: this.currentAsset[addressInfo.id],
      itsmSiteId: this.currentAsset.itsmSiteId,
      itsmSiteName: this.currentAsset.itsmSiteName,
      itsmAddresses: this.settableAddresses,
      addressService: this.addressService,
      targetSystem: this.workflowService.workflowConfig.targetSystem,
      defaultAddress: addressInfo.defaultAddress,
      titleModifier: addressInfo.humanReadableTitle,
      site: this.site,
      hideDeliveryType: type === "service",
      buildingType: type === "service" ? "Service" : "Consumables",
    });

    if (modalResults && modalResults.changed) {
      await this.updateMultiSiteDownloadStaus();
      const foundAddress = this.addresses.find(it => it.id === modalResults.selectedTmcAddressId);
      if (
        addressInfo.allowCreate &&
        !foundAddress &&
        modalResults.createdAddress &&
        modalResults.createdAddress.id &&
        modalResults.createdAddress.itsmBuildingId
      ) {
        this.addresses.push(modalResults.createdAddress);
        this.updateAddressAndContactMaps();
        this.currentAsset[addressInfo.id] = modalResults.selectedTmcAddressId;
        await this.saveAddressesAndContacts();
        this.originalCurrentAsset[addressInfo.id] = modalResults.selectedTmcAddressId;
      } else if (foundAddress) {
        this.currentAsset[addressInfo.id] = modalResults.selectedTmcAddressId;
        await this.saveAddressesAndContacts();
        this.originalCurrentAsset[addressInfo.id] = modalResults.selectedTmcAddressId;
      } else {
        this.error = new Error("Selected address does not exist");
      }
    }
  }

  addContactToDropdown(contact: ItsmContactModel) {
    const newContact: SiteContactsModel = {
      businessPartnerId: contact.businessPartnerId,
      emailAddress: contact.emailAddress,
      firstName: contact.firstName,
      id: contact.id,
      lastName: contact.lastName,
      locale: contact.locale,
      phoneNumber: contact.phoneNumber,
      phoneNumber2: contact.phoneNumber2,
    };
    const contactFound = this.siteContacts.find(it => it.id === newContact.id);
    if (!contactFound) this.siteContacts.push(newContact);
  }

  private isMigrationTargetSystem() {
    const targetSystem = this.workflowService.workflowConfig.targetSystem;
    if (targetSystem === "midmps" || targetSystem === "mimc" ||
    targetSystem === "momc" || targetSystem === "mimp") {
      this.isMigrationProject = true;
    } else {
      this.isMigrationProject = false;
    }
  }

  async saveAddressesAndContacts() {
    const params = { assetId: this.currentAsset.id };
    Object.values(this.addressesInfo).forEach((it) => {
      params[it.id] = (this.currentAsset[it.id] ? this.currentAsset[it.id] : null);
    });
    Object.values(this.contactInfo).forEach((it) => {
      params[it.idUpdate] = (this.currentAsset[it.id] ? this.currentAsset[it.id] : null);
    });
    await this.assetService.setAssetContactAddressIdsItsm(params);
  }

  async closeSelectedAsset() {
    await this.checkCurrentAssetChanges();
    this.closeSelected.emit({ asset: this.currentAsset, changes: this.changesMade });
  }

  async removeSelectedAsset() {
    this.removeSelected.emit(this.currentAsset);
  }

  checkBillFromChanges() {
    if (this.currentAsset.billFromBPIDId) { // if this value exists, validate variables to send
      const f = this.billFromAccounts.find(bf => bf.id === this.currentAsset.billFromBPIDId);
      if (!f) {
        throw new Error("Unable to match selected Bill From Account. Check if this BPID exists in ITSM.");
      }
    }
  }

  async saveSelectedAsset() {
    if (this.selectedCostCenter && this.selectedCostCenter.name) {
      if (
        !this.selectedCostCenter.costCenterId &&
        this.selectedCostCenter.name
      ) {
        // Send new Cost Center to ITSM
        const saveResult = await this.costCenterService.saveCostCenter(
          [this.selectedCostCenter],
          this.itsmCustomerId,
          this.projectId
        );
        if (saveResult && saveResult[0].costCenterId && saveResult[0].name) {
          this.currentAsset.itsmCostCenterId = saveResult[0].costCenterId;
        }
      } else {
        this.currentAsset.itsmCostCenterId =
          this.selectedCostCenter.costCenterId;
      }
    } else {
      this.currentAsset.itsmCostCenterId = this.selectedCostCenter
        ? this.currentAsset.itsmCostCenterId
        : "";
    }
    await this.removeBillFromBpid(this.projectId);
    // Save Cost Center Id in TMC DB
    await this.checkCurrentAssetChanges();
    this.checkBillFromChanges();
    this.saveSelected.emit({
      asset: this.currentAsset,
      changes: this.changesMade,
    });
    this.processing = false;
  }

  async removeBillFromBpid(projectId){
    const params: any = `
        countryId: country_id
        billFromStructure: bill_from_structure
        `;
      const projectInfo = await this.hasuraGqlService.getProjectResponseFromHasura(this.projectId, params);
      if(!this.enableBillFrom || projectInfo.countryId != 'IN'){
        if(this.currentAsset){
          if(Object.keys(this.currentAsset).includes('billFromBPIDId')){
            delete this.currentAsset['billFromBPIDId'];
          }
        }
        if(this.currentAsset.software){
          for(let software of this.currentAsset.software){
            if(Object.keys(software).includes('billFromBPIDId')){
              delete software['billFromBPIDId'];
            }
          }
        }
        if(this.currentAsset.standaloneAccessories){
          for(let standaloneAccessories of this.currentAsset.standaloneAccessories){
            if(Object.keys(standaloneAccessories).includes('billFromBPIDId')){
              delete standaloneAccessories['billFromBPIDId'];
            }
          }
        }
      }
  }
  async changeDetected() {
    await this.checkCurrentAssetChanges();
    this.detectAssetChanges.emit({asset: this.currentAsset, changes: this.changesMade});
  }

  updateCustomField(evt, customKey) {
    //this.currentAsset[customKey] = evt.target.value;
    if (evt.target.value.length > 150)
      (this.customFields.find(c => c.key == customKey)).isvalid = false;
    else
     (this.customFields.find(c => c.key == customKey)).isvalid = true;
    this.changeDetected();
  }
  isInvalidField() {
    let isvalid = true;
    if (this.enableCustomFields) {
      let itm = this.customFields.find(c => c.isvalid == false);
      if (itm != undefined)
        isvalid = false;
    }
    return !isvalid;
  }

  get poDescription() {
    const po = this.purchaseOrders
      .find(el => el.id === this.currentAsset.purchaseOrderId);
    return po ? po["purchaseOrderNumber"] : "";
  }

  async saveSelectedSoftware() {
    const updated = await this.assetService.saveSoftware(this.currentAsset.software.filter(it => it.change));
    if (updated.updated) {
      this.changesMade = false;
      this.saveSoftwareButon = false;
      this.savedSoftware = true;
      updated.software.forEach((it) => {
        const index = this.currentAsset.software.findIndex(el => el.id === it.id);
        this.currentAsset.software[index] = it;
        this.currentAsset.software[index].change = false;
        this.originalCurrentAsset.software[index] = it;
      });
    }
    await this.updateMultiSiteDownloadStaus();
    this.saveSelected.emit({asset: this.currentAsset, changes: this.changesMade});
  }

  async saveContractualContacts() {
    if(this.currentAsset.assetBillToContactId !== this.currentAsset.billToContactId
      || this.currentAsset.assetInvoiceContactId !== this.currentAsset.invoiceContactId
    || this.currentAsset.assetHpAccDeliveryMgrContactId !== this.currentAsset.hpAccDeliveryMgrContactId
    || this.currentAsset.assetHpContractAdminContactId !== this.currentAsset.hpContractAdminContactId
    || this.currentAsset.assetHpInvoiceContactId !== this.currentAsset.hpInvoiceContactId
    || this.currentAsset.assetHpSalesRepContactId !== this.currentAsset.hpSalesRepContactId) {
      this.changesMade = true;
      const asset: any = {
        id: this.currentAsset.id,
        billToContactId: this.currentAsset.billToContactId,
        invoiceContactId: this.currentAsset.invoiceContactId,
        hpAccDeliveryMgrContactId: this.currentAsset.hpAccDeliveryMgrContactId,
        hpContractAdminContactId: this.currentAsset.hpContractAdminContactId,
        hpInvoiceContactId: this.currentAsset.hpInvoiceContactId,
        hpSalesRepContactId: this.currentAsset.hpSalesRepContactId,
      }
      const updated = await this.assetService.saveContractualContacts(asset);
      if (updated.updated) {
        this.changesMade = false;
        this.saveContractualContactButon = false;
        this.savedContractualContact = true;
      }
      this.saveSelected.emit({asset: this.currentAsset, changes: this.changesMade});
      await this.updateMultiSiteDownloadStaus();
    }
  }

  async detectSoftwareChanges(data) {
    if (!this.assetDetailsChanged) {
      this.changesMade = data.changes;
      for (let i = this.enableCustomFields ? 1 : 6; i <= 10; i++)
        this.currentAsset.formGroup.controls[`custom${i}`].markAsDirty();
    }

    this.currentAsset.software = data.software;
    if (data.changes) {
      this.saveSoftwareButon = true;
      this.savedSoftware = false;
    }
    this.detectAssetChanges.emit({asset: this.currentAsset, changes: data.changes});
  }

  async accessoriesChanges(data: DataFromEditAccessoryModel) {
    if (!this.assetDetailsChanged) {
      this.changesMade = data.changes;
      for (let i = this.enableCustomFields ? 1 : 6; i <= 10; i++) this.currentAsset.formGroup.controls[`custom${i}`].markAsDirty();
    }
    this.currentAsset.standaloneAccessories = data.accessories;
    this.originalCurrentAsset.standaloneAccessories = data.accessories;
    this.detectAssetChanges.emit({ asset: this.currentAsset, changes: data.changes });
  }

  dateFormat(field: string) {
    if (!this.currentAsset[field]) return;
    if (this.currentAsset[field].length === 4 || this.currentAsset[field].length === 7) {
      this.currentAsset[field] = `${this.currentAsset[field]}-`;
    }
  }

  async captureSelectedCostCenter(data: CostCenterModel) {
    this.selectedCostCenter = data;
  }

  getBPID() {
    let bpid;
    const found = this.billFromAccounts.find(bf => bf.id === this.currentAsset.billFromBPIDId);
    if (this.billFromAccounts && found) {
      bpid = `BPID: ${found.value.billFromAccBPID}`;
    }
    return bpid;
  }

  async updateMultiSiteDownloadStaus(){
    Query.MULTI_SITE_UPDATE.variables.projectId = this.projectId;
      const params = {
        projectId: this.projectId,
        query: Query.MULTI_SITE_UPDATE,
        uiAction: "SITE-DETAILS",
      }
      const mdfInput = {
        "project_id": this.projectId,
        "file_status":  "invalid"
      };
      Query.MULTI_SITE_UPDATE.variables.input = mdfInput;
      const mdfParams = {
        query: Query.MULTI_SITE_UPDATE,
      }
      const multiSiteFileStatus = await this.hasuraGqlService.getResponseFromHasura(params);
  }
}
